export class TextOption {
  id: string;
  text: string;
  subtext?: string;
  excluding: boolean;

  constructor(id: string, text: string, excluding = false, subtext?: string) {
    this.id = id;
    this.text = text;
    this.subtext = subtext;
    this.excluding = excluding;
  }
}
